import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { environment }  from '@src/environments/environment';

@Component({
  selector: 'app-env-ribbon',
  standalone: true,
  imports: [CommonModule],
  template: `
    @if (!isProduction) {
      <div class="ribbon-container">
        <div class="ribbon">
          {{ envName }}
        </div>
      </div>
    }
  `,
  styles: [`
    /* Contenedor  */
    .ribbon-container {
      position: fixed;
      top: 0;
      left: 0;
      opacity:0.7;
      width: 200px; 
      height: 200px;
      overflow: hidden;
      z-index: 99999; 
      pointer-events: none;
    }

    /* La cinta roja */
    .ribbon {
      position: absolute;
      top: 45px;     
      left: -65px;    
      width: 280px;   
      background-color: #f82727ff; 
      color: white;
      text-align: center;
      line-height: 50px; 
      font-weight: 800;  
      font-size: 24px;  
      transform: rotate(-45deg); 
      box-shadow: 0 5px 10px rgba(0,0,0,0.4); 
      text-transform: uppercase;
      letter-spacing: 2px; 
      font-family: sans-serif;
    }
  `]
})
export class EnvironmentRibbonComponent {
  isProduction = environment.production;
  envName = environment.envName || 'QA'; 
}